<template>
  <page-wrapper :title="title">
    <div class="tabs">
      <div class="tab-navigation">
        <router-link
          v-for="(tab, index) in tabs"
          :key="index"
          :to="{ name: tabRoutes[index] }"
          class="tab-link"
          :class="{ 'active': isActiveTab(tabRoutes[index]) }"
        >
          {{ tab }}
        </router-link>
      </div>
      <div class="tab-content">
        <router-view v-model="value"></router-view>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";

export default {
  components: {
    PageWrapper
  },
  name: "LeadManagementPage",
  data() {
    return {
      title: "ข้อมูล Lead",
      tabs: ["Lead", "Targeting"],
      tabRoutes: ["LeadManagementLead", "LeadManagementTargeting"],
      value: null
    };
  },
  methods: {
    isActiveTab(routeName) {
      return this.$route.name === routeName;
    }
  },
  created() {
    if (this.$route.name === 'LeadManagementPage') {
      this.$router.push({ name: 'LeadManagementLead' });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  padding: 30px;
  border-bottom: $border;
}

.tabs {
  padding-top: 32px;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 32px;
}

.tab-navigation {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 20px;
}

.tab-link {
  padding: 10px 20px;
  margin-right: 10px;
  text-decoration: none;
  color: #333;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;

  &.active {
    border-bottom: 3px solid #ff9800;
    font-weight: bold;
  }

  &:hover {
    background-color: #f5f5f5;
  }
}

.tab-content {
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/features/lead-management/pages/LeadManagementPage.vue